import { BinaryReader } from './binary-reader.js';
import { BinaryWriter } from './binary-writer.js';

export class BinaryHelper {
  static fromIntegersToBytes(list: number[]): Uint8Array {
    const writer = new BinaryWriter((list.length + 1) * BinaryWriter.kBytesPerInt32);

    writer.writeInt32(list.length);

    for(let i = 0; i < list.length; i++) {
      writer.writeInt32(list[i]);
    }

    return writer.toBytes();
  }

  static fromBytesToIntegers(bytes: Uint8Array): number[] {
    const reader = BinaryReader.fromBytes(bytes);
    const length = reader.readInt32();
    const list: number[] = [];

    for(let i = 0; i < length; i++) {
      list.push(reader.readInt32());
    }

    return list;
  }
}
